// extracted by mini-css-extract-plugin
export default {"submitButton":"styles_submitButton__0KSrf"};